export function getUrlParameter(urlParam: string): string | true {
    const pageURL = decodeURIComponent(window.location.search.substring(1));
    const sURLVariables = pageURL.split("&");
    let parameterNameValue: string[];
    let parameterValue: string | true;

    for (let i = 0; i < sURLVariables.length; i++) {
        parameterNameValue = sURLVariables[i].split("=");

        if (parameterNameValue[0] === urlParam) {
            if (parameterNameValue[1] === undefined) parameterValue = true;
            else parameterValue = parameterNameValue[1];
        }
    }

    return parameterValue;
}
